import { ExportToggleField } from './export-toggle-field';

export const CLIENT_NOTES_LABEL = 'Inclure les notes de niveau Client';
export const CLIENT_NOTES_HINT =
  'Ajoute une page « Notes » à la fin : le mémo, puis les discussions ouvertes et leur cible. Les notes Équipe PMS et privées ne sont jamais exportées.';

interface ExportClientNotesFieldProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * « Inclure les notes de niveau Client » (issue #19, planche 16): the export's
 * last option under « Contenu », for the three formats. Off by default, and -
 * like the rest of the selection - not kept by the presets.
 */
export function ExportClientNotesField({ checked, onChange }: ExportClientNotesFieldProps) {
  return (
    <ExportToggleField
      label={CLIENT_NOTES_LABEL}
      checked={checked}
      onChange={onChange}
      hint={CLIENT_NOTES_HINT}
    />
  );
}
